/**
 * Validates that a field is required if another field has a certain value.
 */
export const Validator = {
    name: "required_if_checkbox",
    isImplicit: true,
    errorMessage: "This field is required.",
    validate: function (value, requirement) {
        const [requiredField, requiredValue] = requirement.split(",");
        const val = flatten(this.validator.input)[requiredField];
        if (typeof val === "string") {
            const values = val.split(":");
            if (!values.some(value => value === requiredValue))
                return true;
        }
        if (Array.isArray(value)) {
            return value.length !== 0;
        }
        return value !== "";
    },
};
// TODO: Remove
const dive = (currentKey, into, target) => {
    for (const i in into) {
        if (Object.prototype.hasOwnProperty.call(into, i)) {
            let newKey = i;
            const newVal = into[i];
            if (currentKey.length > 0) {
                newKey = currentKey + "." + i;
            }
            if (typeof newVal === "object") {
                dive(newKey, newVal, target);
            }
            else {
                target[newKey] = newVal;
            }
        }
    }
};
// TODO: Remove
const flatten = (obj) => {
    const newObj = {};
    dive("", obj, newObj);
    return newObj;
};
